export const DefaultFictionNarrativeLabelIds = {
  Book: "narrativeLabelBook",
  Part: "narrativeLabelPart",
  Chapter: "narrativeLabelChapter",
  Scene: "narrativeLabelScene",
  Passage: "narrativeLabelPassage",
  Prologue: "narrativeLabelPrologue",
  Epilogue: "narrativeLabelEpilogue"
};

export const makeNarrativeLabel = (id, label, autoForFolder, autoForOther) => {
  return { id, label, autoForFolder, autoForOther };
};

export default [
  makeNarrativeLabel(DefaultFictionNarrativeLabelIds.Book, "Book", false, false),
  makeNarrativeLabel(DefaultFictionNarrativeLabelIds.Part, "Part", true, false),
  makeNarrativeLabel(DefaultFictionNarrativeLabelIds.Chapter, "Chapter", true, false),
  makeNarrativeLabel(DefaultFictionNarrativeLabelIds.Prologue, "Prologue", false, false),
  makeNarrativeLabel(DefaultFictionNarrativeLabelIds.Epilogue, "Epilogue", false, false),
  makeNarrativeLabel(DefaultFictionNarrativeLabelIds.Scene, "Scene", false, true),
  makeNarrativeLabel(DefaultFictionNarrativeLabelIds.Passage, "Passage", false, true)
];
